import React, { useEffect } from "react";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";

const logo = require("./../assets/img/logo.png");
const toggle = require("./../assets/img/menu-btn.svg").default;

const VendorHeader = () => {
    const { selectedLanguage, changeLanguage, langJson } = useLanguage();

    const onSelectLanguage = (lang) => {
        localStorage.setItem("appLanguage", lang);
        changeLanguage(lang);
    };

    const { sidebarOpenContext, setSidebarOpenContext } = useAuth();

    useEffect(() => {
        $(".mobileBtn").click(() => {
            $(".sideBar").toggleClass("active");
        });

    }, []);

    useEffect(() => {
        if ($(".sidedBar").hasClass("mobileOpen")) {
            // Only runs if sidebarVisible is true AND .sidedBar actually has the class
            $(".sidedBar").removeClass("mobileOpen");
            $("body").removeClass("bodyNoScroll");
        }
    }, [sidebarOpenContext]);

    return (
        <div className="vendorHeader">
            <div className="mainDiv fullContainer">
                <div className="vendorHeaderInner">
                    <li className="mobileBtn" onClick={() => setSidebarOpenContext(true)}>
                        <img src={toggle} alt="image" />
                    </li>
                    <div className="logo">
                        <NavLink to="/">
                            <img src={logo} alt="" />
                        </NavLink>
                    </div>

                    <div className="vendorHeaderLang">
                        <select value={selectedLanguage} onChange={(e) => onSelectLanguage(e.target.value)}>
                            <option value="en">{langJson?.language_english || "English"}</option>
                            <option value="es">{langJson?.language_spanish || "Spanish"}</option>
                            <option value="fr">{langJson?.language_french || "French"}</option>
                            <option value="it">{langJson?.language_italian || "Italian"}</option>
                            <option value="de">{langJson?.language_german || "German"}</option>
                            <option value="ru">{langJson?.language_russian || "Russian"}</option>
                            <option value="tr">{langJson?.language_turkish || "Turkish"}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorHeader;